import { render, staticRenderFns } from "./solution6.vue?vue&type=template&id=5802b778&scoped=true"
import script from "./solution6.vue?vue&type=script&lang=js"
export * from "./solution6.vue?vue&type=script&lang=js"
import style0 from "./solution6.vue?vue&type=style&index=0&id=5802b778&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5802b778",
  null
  
)

export default component.exports